import './resource-indicator.less';
import React from 'react';
import { Row, Col, Modal, Progress } from 'antd';
import ResourceIndicatorDataManager from './ResourceIndicatorDataManager';
import ResourceIndicatorLoadingFailure from './ResourceIndicatorLoadingFailure';

// If you add 'allowFail' (boolean) to the component it will still return 'success'
// so long as at least ONE of the status's is successful.
//
// Ex.
// <ResourceIndicator resources={{ geoData, lookupData, ... }} allowFail />

export default class ResourceIndicator extends ResourceIndicatorDataManager {
    constructor(props) { super(props); }
    render() {
        const { status, progress } = this.state;
        return (
            <div>
                <Modal
                    visible={status === 'pending' || status === 'failure'}
                    width={status === 'failure' ? '300px' : '60%'}
                    footer={null}
                    centered={true}
                    closable={false}
                >
                    {status === 'failure' ? <ResourceIndicatorLoadingFailure /> : (
                        <div>
                            <Row type='flex' justify='center' align='middle' style={{ marginBottom: '4px' }}>
                                <Col className='ss-components-resource-indicator-title'>
                                    {'Loading resource(s)...'}
                                </Col>
                            </Row>
                            <Row type='flex' justify='center' align='middle' style={{ marginBottom: '10px' }}>
                                <Col className='ss-components-resource-indicator-sub-title'>
                                    {'Please wait...'}
                                </Col>
                            </Row>
                            <Row type='flex' justify='center' align='middle'>
                                <Col span={24}>
                                    <Progress percent={progress}/>
                                </Col>
                            </Row>
                        </div>
                    )}
                </Modal>
            </div>
        );
    }
}
